import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import deviceController from '../../redux/api/tbDeviceController';
import telemetryController from '../../redux/api/tbTelemetryController';

export const initialState = {
  device: [],
  status: 'idle',
};

export const getDataDevice = createAsyncThunk('deviceList', async (data) => {
  const { token, customerId, pageSize, page } = data;
  const response = await deviceController.getCustomerDevices(
    token,
    customerId,
    pageSize,
    page
  );
  const result = await Promise.all(
    response.data.map(async (item) => {
      let attributes = await telemetryController.getAttributesByScope(
        token,
        'DEVICE',
        item.id.id,
        'lastConnectTime,lastDisconnectTime,latitude,longitude,device_avatar,operationImage,operationData,phoneList,lastActivityTime'
      );
      let avatar, lastActivityTime, lastConnectTime, lastDisconnectTime, latitude, longitude, operationImage, operationData, phoneList;
      Object.values(attributes).map((item) => {
        if (item['key'] === 'phoneList') phoneList = item.value;
        if (item['key'] === 'device_avatar') avatar = item.value;
        if (item['key'] === 'lastActivityTime') lastActivityTime = item.value;
        if (item['key'] === 'lastConnectTime') lastConnectTime = item.value;
        if (item['key'] === 'lastDisconnectTime')
          lastDisconnectTime = item.value;
        if (item['key'] === 'latitude') latitude = item.value;
        if (item['key'] === 'longitude') longitude = item.value;
        if (item['key'] === 'operationImage') operationImage = item.value;
        if (item['key'] === 'operationData') operationData = item.value;
      });
      return {
        ...item,
        attributes: {
          lastActivityTime: lastActivityTime,
          lastConnectTime: lastConnectTime,
          lastDisconnectTime: lastDisconnectTime,
          avatar: avatar,
          longitude: longitude ? longitude : 0,
          latitude: latitude ? latitude : 0,
          operationImage: operationImage,
          operationData: operationData,
          phoneList: phoneList
        },
      };
    })
  );
  return result;
});

export const assignDeviceToCustomer = createAsyncThunk(
  'assignDeviceToCustomer',
  async (data) => {
    const { token, newCustomerId, deviceId } = data;
    const response = await deviceController.assignDeviceToCustomer(
      token,
      newCustomerId,
      deviceId
    );
    return response;
  }
);

export const saveDevice = createAsyncThunk('saveDevice', async (data) => {
  const {
    token,
    deviceId,
    deviceProfileId,
    customerId,
    name,
    label,
    description,
    file,
    latitude,
    longitude
  } = data;
  const response = await deviceController.getDeviceCredentialsByDeviceId(
    token,
    deviceId
  );
  const accessToken = response.credentialsId;
  const result = await deviceController.saveDevice(token, accessToken, {
    id: {
      entityType: 'DEVICE',
      id: deviceId,
    },
    deviceProfileId: {
      id: deviceProfileId,
      entityType: 'DEVICE_PROFILE',
    },
    customerId: {
      id: customerId,
      entityType: 'CUSTOMER',
    },
    name: name,
    label: label,
    additionalInfo: {
      description: description,
    },
  });
  const responseAvatar = await telemetryController.saveEntityAttributesV1(
    token,
    'DEVICE',
    result.id.id,
    {
      device_avatar: file,
      latitude: latitude,
      longitude: longitude
    }
  );
  return responseAvatar;
});

export const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDataDevice.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getDataDevice.fulfilled, (state, action) => {
      state.status = 'idle';
      state.device = action.payload;
    });
    builder.addCase(getDataDevice.rejected, (state) => {
      state.status = 'failed';
      state.device = [];
    });
    // assignDeviceToCustomer
    builder.addCase(assignDeviceToCustomer.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(assignDeviceToCustomer.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success(
        'The device has been successfully transferred to another customer.'
      );
    });
    builder.addCase(assignDeviceToCustomer.rejected, (state) => {
      state.status = 'failed';
      toast.error('Something went wrong!');
    });
    // edit device info
    builder.addCase(saveDevice.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(saveDevice.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success('Successfully saved device information.');
    });
    builder.addCase(saveDevice.rejected, (state) => {
      state.status = 'failed';
      toast.error('The name device cannot be the same as the existing name.');
    });
  },
});

export default deviceSlice.reducer;

export const allDevicesCustomer = (state) => state.device.device;
